import { shuffleArray } from 'root/lib/utilityFunctions';
import { GAME_ID, REDUX_ACTIONS } from '../../data/constants';

const initialState = {
  hasSelected: false,
  selectedIndex: -1,
  isFirstTimeSelectingInference: true,
  isDiscarding: false,
  choices: [],
  areInferencesRevealed: false,
};

const inferenceReducer = (state = initialState, { type, gameId, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.INITIALIZE_ITEM:
      return {
        ...state,
        choices: parseInferenceChoicesToChoices(payload.inferenceChoices),
        areInferencesRevealed: false,
        isFirstTimeSelectingInference: true,
      };
    case REDUX_ACTIONS.SET_SELECTED_INFERENCE_INDEX:
      return {
        ...state,
        selectedIndex: state.selectedIndex === payload ? -1 : payload,
        isFirstTimeSelectingInference: false,
      };
    case REDUX_ACTIONS.DISCARD_SELECTED_INFERENCE_CHOICE: {
      const nextChoices = [...state.choices];
      nextChoices[state.selectedIndex].isDiscarded = true;
      return {
        ...state,
        choices: nextChoices,
      };
    }
    case REDUX_ACTIONS.DESELECT_INFERENCE: {
      return {
        ...state,
        selectedIndex: -1,
      };
    }
    case REDUX_ACTIONS.CHANGE_SCREEN:
      return {
        ...state,
        selectedIndex: -1,
        hasSelected: false,
      };
    case REDUX_ACTIONS.SET_IS_INFERENCE_PANEL_DISCARDING: {
      return {
        ...state,
        isDiscarding: payload.isDiscarding,
      };
    }
    case REDUX_ACTIONS.ON_REVEAL_INFERENCE_CHOICES:
      return {
        ...state,
        areInferencesRevealed: true,
      };
    default:
      return state;
  }
};

export default inferenceReducer;

const parseInferenceChoicesToChoices = inferenceChoices =>
  shuffleArray(inferenceChoices.map(inference =>
    ({
      ...inference,
      isDiscarded: false,
    })));
